import { Box, Fab } from "@mui/material";
import Add from "@mui/icons-material/Add";
import { tabBarOffset } from "../../misc/MobileTabBar";
import { projectBarHeight } from "./day/ProjectDrawer";

// gap is the space between the button and the project bar under it, in px
const gap = 16;

// NewTaskFab is a phone's main way to add a task: it floats in thumb reach above the
// project bar (see ProjectDrawer), on every scroll position of the page
export function NewTaskFab(props: { onClick: () => void }) {
    return (
        <>
            {/* holds the page's last row clear of the button */}
            <Box sx={{ height: 56 + gap }} />

            <Fab variant="extended" color="primary" onClick={props.onClick} sx={{
                position: "fixed",
                right: 16,
                bottom: `calc(${tabBarOffset} + ${projectBarHeight + gap}px)`,
                textTransform: "none",
                fontWeight: 600,
            }}>
                <Add sx={{ mr: 1 }} />
                Add task
            </Fab>
        </>
    );
}
